import { ReactComponentManifest } from "web/entrypoints/common/setup";
import HomepageLayout from "web/react/components/__LEGACY__/homepage-layout/homepage-layout";
import AdsenseShopping from "web/react/components/adsense-shopping/adsense-shopping";
import { Stories } from "web/react/pages/home/stories";
import withRedux from "web/react/redux-provider";

const components: ReactComponentManifest = {
    AdsenseShopping: withRedux(AdsenseShopping),
    HomepageLayout,
    Stories: withRedux(Stories),
};

export default components;
